import transform from '@diplodoc/transform';
import defaultPlugins from '@diplodoc/transform/lib/plugins';
import checkbox from '@diplodoc/transform/lib/plugins/checkbox';
import DOMPurify from 'dompurify';

// HTML в тексте не разрешён (allowHTML по умолчанию false), DOMPurify — второй рубеж: текст задач пишут пользователи.
// Чекбоксы `[ ]`/`[x]` по умолчанию не включены; idPrefix — чтобы id не совпадали у описания и комментариев
export const renderMarkdown = ({ text, idPrefix }: { text: string; idPrefix: string }) =>
  DOMPurify.sanitize(
    transform(text, {
      breaks: true,
      linkify: true,
      plugins: [...defaultPlugins, (md) => checkbox(md, { idPrefix })],
    }).result.html,
  );
